<div class="account-reports">
  <div class="container py-3">
    <h2 class="mb-3">Reports</h2>

    <div class="d-flex flex-column gap-2">
      <a class="export-link" href="javascript:void(0)" (click)="openExportStatements()">Export statement</a>
      <a class="export-link" href="javascript:void(0)" (click)="openExportCheckins()">Export Check-ins</a>
    </div>
  </div>
</div>
